import React, { useEffect, useState } from "react";
import { Row, Col, Drawer, Button, notification, Skeleton } from "antd";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import styles from "./TripDetailsDrawer.module.scss";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import moreIcon from "../../../assets/icons/moreOutlined.svg";
import { useDashboardCtx } from "../../../context/DashboardContext";
import { Tabs } from "../../../types/TripPaginationFilterTypes";
import FavoriteTripDetails from "./FavoriteTripDetails";
import UpcomingAndPastTripDetails from "./UpcomingAndPastTripDetails";
import { RebookTripOptions } from "../../../hooks/useTripActions";
import rebookIcon from "../../../assets/icons/retweetWhiteOutlined.svg";
import DropdownActions from "../ServicesTable/DropdownActions";
import moment from "moment";
import { getTripByRequestAssignmentId } from "../../../services";

export type ActionHandlerFunctions = {
  handleAddFavorite: (leg: ITripDetails) => void;
  handleRebook: (options: RebookTripOptions) => void;
  handleCancelService: (leg: ITripDetails) => void;
  handleRemoveFavorite: (leg: ITripDetails) => void;
  handleRenameFavorite: (leg: ITripDetails) => void;
};

type Props = {
  openTripDetails: boolean;
  setOpenTripDetails: Function;
  selectedLeg: ITripDetails;
  actionHandlers: ActionHandlerFunctions;
  favoriteTrip: ITripDetails[];
  isLoadingFavTrip: boolean;
};

function TripDetailsDrawer({
  openTripDetails,
  setOpenTripDetails,
  selectedLeg,
  actionHandlers,
  favoriteTrip,
  isLoadingFavTrip,
}: Props) {
  const [activeTripDetailsTab, setActiveTripDetailsTab] = useState<string>("1");

  const { handleRebook } = actionHandlers;
  const { activeTabCtx } = useDashboardCtx();
  const [activeTab] = activeTabCtx;
  const isFavoriteTab = activeTab === Tabs.FAVORITE;

  function handleTabChange(activeKey: string): void {
    setActiveTripDetailsTab(activeKey);
  }

  function handleOnClose() {
    setActiveTripDetailsTab("1");
    setOpenTripDetails(false);
  }
  
  function renderFavoriteName() {
    if (isFavoriteTab) {
      return isLoadingFavTrip ? (
        <Skeleton active />
      ) : (
        favoriteTrip[0]?.favoriteName
      );
    }
    return "Service Details";
  }

  function renderServiceUser() {
    if (isFavoriteTab && isLoadingFavTrip) {
      return <Skeleton active />;
    }
    return selectedLeg?.serviceUser;
  }

  return (
    <Drawer
      title={
        <>
          <Row gutter={[0, 14]}>
            <Col span={24} className={textStyles.normalText20}>
              {renderFavoriteName()}
            </Col>
            <Col span={12}>
              <Row className={textStyles.normalText12}>Service user</Row>
              <Row className={textStyles.normalText16}>
                {renderServiceUser()}
              </Row>
            </Col>
            <Col span={12}>
              <Row justify="end">
                <DropdownActions
                  selectedLeg={selectedLeg}
                  actionHandlers={actionHandlers}
                  isTripDetailsView={openTripDetails}
                >
                  <Button className={styles.actionsBtn}>
                    <img src={moreIcon} alt="actions" /> Action
                  </Button>
                </DropdownActions>
              </Row>
            </Col>
          </Row>
          {!isFavoriteTab ? (
            <Row gutter={[0, 4]}>
              <Col span={24} />
              <Col span={24}>
                <Row className={textStyles.normalText12}>Booking ID</Row>
                <Row className={textStyles.normalText16}>
                  {selectedLeg?.bookingId}
                </Row>
              </Col>
            </Row>
          ) : (
            <Row gutter={[0, 16]}>
              <Col span={24} />
              <Button
                className={styles.favRebookBtn}
                onClick={() => handleRebook({ allLegs: favoriteTrip })}
              >
                <img src={rebookIcon} alt="rebook_service" />
                Rebook service
              </Button>
            </Row>
          )}
        </>
      }
      placement="right"
      className={`${styles.drawerContainer} ${isFavoriteTab &&
        styles.favDetailsDrawerAlign}`}
      onClose={handleOnClose}
      visible={openTripDetails}
    >
      {isFavoriteTab ? (
        <FavoriteTripDetails
          isLoading={isLoadingFavTrip}
          favoriteTrip={favoriteTrip}
        />
      ) : (
        <UpcomingAndPastTripDetails
          selectedLeg={selectedLeg}
          activeTripDetailsTab={activeTripDetailsTab}
          handleTabChange={handleTabChange}
        />
      )}
    </Drawer>
  );
}

export default TripDetailsDrawer;
